import React from 'react';
import PropTypes from 'prop-types';

import LandingPageIntro from './LandingPageIntro';
import LandingPageContent from './LandingPageContent';
import LandingPageFooter from './LandingPageFooter';
import ScrollIndicator from './ScrollIndicator';

/**
 * Displays landing page with log-in buttons.
 */
const LandingPage = ({ aMaintenanceAlerts }) => (
  <div className='landingPage'>
    <main className='landingPage__main'>
      <LandingPageIntro aMaintenanceAlerts={aMaintenanceAlerts} />
      <LandingPageContent />
    </main>
    <LandingPageFooter />
    <ScrollIndicator />
  </div>
);

LandingPage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  aMaintenanceAlerts: PropTypes.array,
};

LandingPage.defaultProps = {
  aMaintenanceAlerts: [],
};

export default LandingPage;
